import $ from 'cash-dom';
$('button[data-action="show-password"]').on('click', function () {
    const elm = $(this).closest('.input-group').children('input.js-visible-password');

    if (elm.attr('type') === 'password') {
        elm.attr('type', 'text');
        $(this).text($(this).data('textHide'));
    } else {
        elm.attr('type', 'password');
        $(this).text($(this).data('textShow'));
    }
});